(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["com.severstal.stun-v2.1.9-268"] = factory();
	else
		root["com.severstal.stun-v2.1.9-268"] = factory();
})(globalThis, () => {
return 